import React, { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../components/shared/Loader";
import Nestable from "react-nestable";
import { useDispatch, useSelector } from "react-redux";
import { updateMeta } from "../store/actions/metaAction";

const Menu = () => {
	const auth = useSelector(state => state.auth.user);
	const [loading, setLoading] = useState(true);
	const [text, setText] = useState("");
	const [link, setLink] = useState("");
	const [items, setItems] = useState([]);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "التحكم في عناصر القائمة",
				breadcrumb: "قائمة الموقع",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}/posts/menus/all`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				let finalData = [];
				// eslint-disable-next-line array-callback-return
				response.data.data[0].categories[0].posts[0].data.map(post => {
					const data = {
						id: post.id,
						text: post.text,
						link: post.link,
						children: post.children,
					};
					finalData.push(data);
				});
				setItems(finalData);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
				setLoading(false);
			});
	};

	const renderItem = ({ item }) => item.text;

	const handleChange = items => {
		setItems(items.items);
		axios.put(
			`${process.env.REACT_APP_API_URL}/posts/150`,
			{
				category_id: 17,
				admin_id: auth.data.id,
				data: items.items,
			},
			{
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			}
		);
	};

	const handleDelete = item => {
		const arr = items.filter(one => {
			return one.id !== item.id;
		});
		setItems(arr);
		axios.put(
			`${process.env.REACT_APP_API_URL}/posts/150`,
			{
				category_id: 17,
				admin_id: auth.data.id,
				data: arr,
			},
			{
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			}
		);
	};

	const handleDeleteChild = (item, child) => {
		let childsWithoutTheOne = item.children.filter(one => {
			return one.id !== child.id;
		});
		const newState = Object.assign({}, items);
		item.children = childsWithoutTheOne;
		const final = Object.values(newState);
		setItems(final);
		axios.put(
			`${process.env.REACT_APP_API_URL}/posts/150`,
			{
				category_id: 17,
				admin_id: auth.data.id,
				data: final,
			},
			{
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			}
		);
	};

	const handleSubmit = e => {
		const newItem = {
			id: Math.floor(Math.random() * 100),
			text: text,
			link: link,
			children: [],
		};
		const newArray = [...items, newItem];
		setItems(newArray);
		e.preventDefault();
		axios
			.put(
				`${process.env.REACT_APP_API_URL}/posts/150`,
				{
					category_id: 17,
					admin_id: auth.data.id,
					data: newArray,
				},
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(function (response) {
				toast.success("تم الاضافة بنجاح!");
				setText("");
				setLink("");
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
			});
	};

	const handleUpdateText = (event, item) => {
		let currentItems = [...items];
		item.text = event.target.value;
		setItems(currentItems);
		axios.put(
			`${process.env.REACT_APP_API_URL}/posts/150`,
			{
				category_id: 17,
				admin_id: auth.data.id,
				data: currentItems,
			},
			{
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			}
		);
	};

	const handleUpdateChildText = (event, item, child) => {
		let currentItems = [...items];
		child.text = event.target.value;
		setItems(currentItems);
		axios.put(
			`${process.env.REACT_APP_API_URL}/posts/150`,
			{
				category_id: 17,
				admin_id: auth.data.id,
				data: currentItems,
			},
			{
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			}
		);
	};

	return (
		<>
			{loading && <Loader />}
			<section>
				<div className="row">
					<div className="col-md-4">
						<div className="card">
							<div className="card-header">التحكم في العناصر</div>
							<div className="card-body">
								<ul className="list-unstyled">
									{items.map(item => (
										<li key={item.id}>
											<div className="menu-item">
												<input
													type="text"
													value={item.text}
													onChange={e => handleUpdateText(e, item)}
												/>
												<button onClick={() => handleDelete(item)}>
													<i className="fas fa-trash"></i>
												</button>
											</div>
											{item.children.length > 0 && (
												<ul>
													{item.children.map(child => (
														<li key={child.id}>
															<div className="menu-item">
																<input
																	type="text"
																	value={child.text}
																	onChange={e =>
																		handleUpdateChildText(e, item, child)
																	}
																/>
																<button
																	onClick={() => handleDeleteChild(item, child)}
																>
																	<i className="fas fa-trash"></i>
																</button>
															</div>
														</li>
													))}
												</ul>
											)}
										</li>
									))}
								</ul>
							</div>
						</div>
						<div className="card mt-5">
							<div className="card-header">اضافة عنصر جديد</div>
							<div className="card-body">
								<form onSubmit={handleSubmit}>
									<div className="menu-item">
										<input
											type="text"
											required
											value={text}
											placeholder="العنوان"
											onChange={e => setText(e.target.value)}
										/>
									</div>
									<div className="menu-item">
										<input
											type="text"
											required
											value={link}
											placeholder="الرابط"
											onChange={e => setLink(e.target.value)}
											style={{ textAlign: "left", direction: "ltr" }}
										/>
									</div>
									<button className="bt bt-success">اضافة</button>
								</form>
							</div>
						</div>
					</div>
					<div className="col-md-8">
						<div className="card">
							<div className="card-header">ترتيب العناصر</div>
							<div className="card-body">
								<Nestable
									items={items}
									renderItem={renderItem}
									onChange={items => handleChange(items)}
								/>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default Menu;
